import {BrandPreview} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand_preview.types';
import {
  BrandLogo,
  COLORS,
  desktopAndUp,
  FONT_SIZES,
  FONT_WEIGHTS,
  largeScreens,
  mediaMaxMSBreakpoint,
  mediaMaxXSBreakpoint,
  tabletAndUp,
} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';

interface BrandPageHeaderLogoProps {
  className?: string;
  brand: BrandPreview;
}

const breakpoints = [
  {breakpoint: `(max-width: ${mediaMaxXSBreakpoint}px)`, columns: 2},
  {breakpoint: `(max-width: ${mediaMaxMSBreakpoint}px)`, columns: 3},
  {columns: 4},
];

export const BrandPageHeaderLogo: React.FC<BrandPageHeaderLogoProps> = ({
  brand,
  className,
}) => {
  const brandLogo =
    brand.type?.$case === 'images'
      ? brand.type.images.whiteLogoImage
      : undefined;

  return (
    <Wrapper
      className={className}
      data-has-logo={Boolean(brandLogo)}
      data-testid="BrandLogo"
    >
      <StyledBrandLogo
        image={brandLogo}
        name={brand.brand.name}
        breakpoints={breakpoints}
        alignment="bottom"
        showTooltip={false}
        maxWidth="100%"
        maxHeight="100%"
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  &[data-has-logo='true'] {
    width: 50%;
    height: 30%;

    ${tabletAndUp(css`
      width: 35%;
    `)}

    ${largeScreens(css`
      width: 22%;
    `)}
  }
`;

const StyledBrandLogo = styled(BrandLogo)`
  display: block;
  text-align: center;
  font-size: ${FONT_SIZES.px32};
  line-height: ${FONT_SIZES.px40};
  font-weight: ${FONT_WEIGHTS.bold};
  color: ${COLORS.White};

  ${desktopAndUp(css`
    font-size: ${FONT_SIZES.px40};
    line-height: ${FONT_SIZES.px48};
  `)}
`;
